/**
 * Strings of the visual overhaul's WP5 (settings, auth, dialogs)
 * (docs/design/visual-overhaul.md §11). Merged into the catalogue after
 * every other table, so a key here may override an older one.
 */
import type { Dict } from '../core';

export const settingsEn: Dict = {
  // the key under the close button reads as the palette's does (T21)
  'set.esc': 'Esc',
  // Server settings' nav groups (§6.9)
  'adm.group.server': 'Server',
  'adm.group.mod': 'Moderation',
  // Appearance: reduced motion and transparency (I12, C29)
  'set.motion': 'Reduce motion',
  'set.motion.sub': 'Turns off movement such as sliding and scaling. Fades stay.',
  'set.motion.system': 'System',
  'set.motion.on': 'On',
  'set.motion.off': 'Off',
  'set.glass': 'Transparency',
  'set.glass.sub': 'Reduced draws solid surfaces instead of see-through glass.',
  'set.glass.full': 'Full',
  'set.glass.flat': 'Reduced',
  // Appearance: the background behind the glass (2026-10-30)
  'set.bg': 'Background',
  'set.bg.sub': 'Glass glow is the colour glow behind the app. Solid is one plain colour.',
  'set.bg.glow': 'Glass glow',
  'set.bg.solid': 'Solid',
  'set.bg.colour': 'Colour',
  'set.bg.black': 'Pure black',
  'set.bg.charcoal': 'Charcoal',
  'set.bg.midnight': 'Midnight blue',
  'set.bg.white': 'Pure white',
  'set.bg.grey': 'Soft grey',
  // password fields (§7.21, P29)
  'auth.pw.show': 'Show password',
  'auth.pw.hide': 'Hide password',
};
